// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2J_zN","rightAdornment":"Header_rightAdornment__1MxUt"};